import React from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'
import Configurator from '../../configurator'
import { i18n } from '../../validator'
import Button from '../../front/components/shared/sn-button'
import SnIcon from '../../front/components/shared/sn-icon'
import Modal from '../modal'
import { setSystemRedirectClear } from '../../admin/actions/system-redirect'
import { getRemoteLoginLink } from '../auth/remote-login-redirect'
import { LinkOrDiv } from '../../front/components/events/helpers'

@i18n()
class SystemRedirect extends Configurator {

    /**
     * Redirect to forward link and clear redirect links from store
     */
    redirectForward = () => {
        const { forwardLink } = this.props.systemRedirect

        if (forwardLink) {
            window.location.href = forwardLink
        }

        setSystemRedirectClear()
    }

    /**
     * Redirect to back link and clear redirect links from store
     */
    redirectBack = () => {
        const { backLink } = this.props.systemRedirect

        if (backLink) {
            window.location.href = backLink
        }

        setSystemRedirectClear()
    }

    /**
     * Get content (text and image) for modal
     * @returns {{image: string, label, backText}}
     */
    getImageAndTextsForContent = () => {
        const {
            t,
            systemRedirect: {
                isLoginRedirect,
            },
        } = this.props

        let labelKey = ''

        if (isLoginRedirect) {
            labelKey = 'systemRedirect.labelLogin'
        } else {
            labelKey = 'systemRedirect.labelFunction'
        }

        const {
            REACT_APP_SYSTEM_REDIRECT_IMAGE: image,
            REACT_APP_SYSTEM_REDIRECT_FROM_SYSTEM: fromSystem,
        } = this.config

        return {
            label: t(labelKey, {
                fromSystem: (<span className="font-weight-bold">{fromSystem}</span>),
                toSystem: (<span className="text-color-brand font-weight-bold">Sportnect.com</span>),
            }),
            image: image,
            backText: t('systemRedirect.backButton', { system: fromSystem }),
        }
    }

    /**
     * Render content of component
     * @returns {*}
     */
    renderContent = () => {
        const {
            webview,
            t,
            systemRedirect,
            systemRedirect: {
                isLoginRedirect,
                forwardLink,
            },
        } = this.props

        if (!systemRedirect) {
            return null
        }

        const forContent = this.getImageAndTextsForContent()

        return (
            <div className={classnames({
                'p-3 d-flex flex-column justify-content-between': true,
                'min-vh-100': webview,
            })}>
                <img className="w-100 mb-5" src={forContent.image} alt='' />
                <div className="mb-5">{forContent.label}</div>
                <div>
                    {!isLoginRedirect && (
                        <Button
                            className="btn btn-color-brand btn-circle d-flex flex-direction justify-content-center align-items-center w-100 mb-3"
                            onClick={() => this.redirectForward()}
                        >
                            <span>{t('continueToSportnect')}</span>
                            <SnIcon className="sn-arrow sn-sm sn-rotate-180" />
                        </Button>
                    )}
                    {isLoginRedirect && (
                        <div onClick={() => setSystemRedirectClear()}>
                            <LinkOrDiv
                                className="btn btn-color-brand btn-circle d-flex flex-direction justify-content-center align-items-center w-100 mb-3"
                                href={forwardLink}
                                reactLink={forwardLink !== getRemoteLoginLink()}
                            >
                                <span>{t('continueToSportnect')}</span>
                                <SnIcon className="sn-arrow sn-sm sn-rotate-180" />
                            </LinkOrDiv>
                        </div>
                    )}
                    <div
                        className="w-100 cursor-pointer text-center text-color-gray-dark-3 font-weight-bold"
                        onClick={() => this.redirectBack()}
                    >
                        {forContent.backText}
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const { webview } = this.props

        if (webview) {
            return this.renderContent()
        }

        return (
            <Modal
                content={this.renderContent}
                dialogClass="max-width-400"
                handleHideModal={() => setSystemRedirectClear()}
                withoutHeader
            />
        )
    }
}

export default connect(state => ({
    systemRedirect: state.systemRedirect,
}))(SystemRedirect)
